import { render, staticRenderFns } from "./RomanBlind.vue?vue&type=template&id=63fdb650"
import script from "./RomanBlind.vue?vue&type=script&lang=js"
export * from "./RomanBlind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports